import request from '@/utils/request'

// 获取网站基础配置
export const getSiteConfig = () => {
  return request({
    url: '/config/site',
    method: 'get'
  })
}

// 获取导航菜单
export const getNavigation = () => {
  return request({
    url: '/config/navigation',
    method: 'get'
  })
}

// 获取底部链接配置
export const getFooterConfig = () => {
  return request({
    url: '/config/footer',
    method: 'get'
  })
}
